export const APP_SETTING_KEY = {
  TERMS_ACCEPTED_VERSIONS: 'terms.acceptedVersions',
  THEME_PREFERENCE: 'appearance.themePreference',
} as const;
